export const today = (): number => {
  return Math.floor(new Date().setUTCHours(0, 0, 0, 0) / 1000);
}

export const tomorrow = (): number => {
  return today() + (24 * 60 * 60);
}

export const uniqueId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
}
